/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiation-technique.reducer';

export const RadiationTechniqueDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiationTechniqueEntity = useAppSelector(state => state.radiationTechnique.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiationTechniqueDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiationTechnique.detail.title">RadiationTechnique</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.name">Name</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.description">Description</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiationTechnique.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiationTechniqueEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/radiation-technique" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiation-technique/${radiationTechniqueEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiationTechniqueDetail;
